/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const moreVertical = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M13 19h-2v-2h2v2zm0-6h-2v-2h2v2zm0-6h-2V5h2v2z" />
	</SVG>
);

export default moreVertical;
